"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zavattarello": {
    "d1d034ac": [{
      "hkey": "5111d5a3",
      "slug": "zavattarello",
      "name": "Zavattarello",
      "primary": true,
      "skipSearch": false
    }],
    "casa-rubero": [{
      "hkey": "5111d5a3",
      "slug": "zavattarello",
      "name": "Zavattarello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0165181": [{
      "hkey": "5111d5a3",
      "slug": "zavattarello",
      "name": "Zavattarello",
      "primary": true,
      "skipSearch": false
    }],
    "pradelle": [{
      "hkey": "5111d5a3",
      "slug": "zavattarello",
      "name": "Zavattarello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "974303ef": [{
      "hkey": "5111d5a3",
      "slug": "zavattarello",
      "name": "Zavattarello",
      "primary": true,
      "skipSearch": false
    }],
    "tovazza": [{
      "hkey": "5111d5a3",
      "slug": "zavattarello",
      "name": "Zavattarello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;